export default import.meta.ROLLDOWN_FILE_URL_ZfojLTyLoZjYVmH6_74xTg